<template>
    <router-link :to="{ path: href, params: { category: slug }}" @click.native="emitClick" class="tile-link">
        <div :class="[slug, 'tile']">
            <h3 :class="color" class="uk-h2">{{name}}</h3>
            <div v-if="backgroundImage" :style="backgroundImage" class="tile-background" />
        </div>
    </router-link>
</template>

<script>
export default {
    props: {
        name: {
            type: String,
            required: true
        },
        slug: {
            type: String,
            required: true
        },
        color: {
            type: String,
            required: true
        },
        image: {
            type: String,
            default: ''
        },
        href: {
            type: String
        }
    },
    computed: {
        backgroundImage () {
            return this.image ? 'background-image: url('+this.image+')' : null
        }
    },
    methods: {
        emitClick () {
            this.$emit('hasClick')
        }
    }
}
</script>

<style lang="scss">
    .tile-link {
        z-index: 1;
    }
    .tile {
        position: relative;
        padding-bottom: 100%;
        background: black;

        > h3 {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translateX(-50%) translateY(-50%) scale(1);
            z-index: 10;
            transition: transform $transition;
        }

        &:hover {
            .tile-background {
                opacity: 0.7;
                transition: 0.3s ease;
            }

            > h3 {
                @include mq($from: medium) {
                    transition: transform $transition;
                    transform: translateX(-50%) translateY(-50%) scale(1.2);
                }
            }
        }

        &-background {
            position: absolute;
            width: 100%;
            height: 100%;
            top: 0;
            left: 0;
            opacity: 0.5;
            background-size: cover;
            background-position: 50% 50%;
            z-index: 0;
            transition: 0.3s ease;
        }
    }
</style>




// WEBPACK FOOTER //
// src/components/PortfolioCategoryTile.vue